let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("av45U")).then(() => parcelRequire('7gIjf'));